export default __webpack_public_path__ + "images/1dbcf6883934971dff621326b17aa174-sales_and_marketing.jpg";